import React, { useEffect, useState } from "react";
import "./Footer.scss";


function Footer() {
	const [year, setYear] = useState('')
	useEffect(() => {
		const d = new Date();
		setYear(d.getFullYear());
	}, [])

	return (
		<>
			<div className="footer-wrapper mt-2">
				<div className="container">
					<div className="footer py-2  d-flex flex-wrap justify-content-between">
						<div className="d-flex align-items-center">
							<a href='https://www.qwikresume.com/terms-of-service/' target="_blank"><p className="m-0">Terms of Service</p></a>
							<div className="dot mx-2"></div>
							<a href='https://www.qwikresume.com/privacy-policy/' target="_blank"><p className="m-0">Privacy Policy</p></a>
						</div>
						<div>
							<p className="m-md-0 mt-2">
								Copyright © {year} QwikResume™. All rights reserved.
							</p>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Footer;
